"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoadingDots = void 0;
const tslib_1 = require("tslib");
const core_1 = require("@emotion/core");
const styled_1 = tslib_1.__importDefault(require("@emotion/styled"));
const react_core_1 = require("@neo-one/react-core");
const React = tslib_1.__importStar(require("react"));
const styled_tools_1 = require("styled-tools");
const animation = core_1.keyframes `
  0%,
  80%,
  100% {
    transform: scale(0);
  }

  40% {
    transform: scale(1);
  }
`;
const Wrapper = styled_1.default(react_core_1.Box) `
  height: 16px;
  display: grid;
  grid-auto-flow: column;
  align-items: center;

  & > div {
    width: 5.33333px;
    height: 5.33333px;
    background-color: ${styled_tools_1.prop('theme.accent')};
    border-radius: 100%;
    display: inline-block;
    animation: ${animation} 1.4s infinite ease-in-out;
    animation-fill-mode: both;
  }

  & > div:first-of-type {
    animation-delay: -0.32s;
  }

  & > div:nth-of-type(2) {
    animation-delay: -0.16s;
  }
`;
exports.LoadingDots = (props) => (React.createElement(Wrapper, Object.assign({}, props),
    React.createElement("div", null),
    React.createElement("div", null),
    React.createElement("div", null)));

//# sourceMappingURL=LoadingDots.js.map
